import { render, staticRenderFns } from "./ListaEncuestasView.vue?vue&type=template&id=de6c51c4"
import script from "./ListaEncuestasView.vue?vue&type=script&lang=ts"
export * from "./ListaEncuestasView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports